import ITask from './ITask';
import {
    OverlayFadeIn,
    Scale,
} from '../../System/Animation/Clip';
import {
    ConcatIterators,
    PlayAnimation,
} from '../../System/Animation/AnimationHelper';
import WorldSystem from '../../System/World/WorldSystem';
import GameObject from '../../GameObject/GameObject';
import RenderSystem, { RenderSystemEvent } from '../../System/Render/RenderSystem';
import OverlayComponent from '../../Component/UI/Overlay';
import Game from '../../Game';
import Point from '../Point';
import Text from '../../Prototype/Text';
import { Easing } from '@tweenjs/tween.js';
import WorldUISystem from 'System/UI/WorldUISystem';
import Arrow from 'Prototype/Level/Arrow';
import TransformComponent from 'Component/Transform';
import Interactable from 'Component/Interactable';

export default class FarmBtnFTUXTask implements ITask<WorldSystem> {
    public *execute(system: WorldSystem): IterableIterator<any> {
        system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);
        const overlay = system.animator.getChildByName('overlay');
        const worldHudHandler = system.scene.getSystem(WorldUISystem).hud;
        const farmButton = worldHudHandler.farmButton;

        const arrow: Arrow = GameObject.Instantiate(Arrow, {
            name: 'farm_arrow',
            position: new Point(0, 40),
            texture: 'farm_arrow',
            meta: {
                speed: 400,
                offset: new Point(0, 20)
            },
        });
        
        const text = GameObject.Instantiate(Text, {
            position: new Point(0, 0),
            text: Game.locale.getText('FarmFTUX1'),
            style: Game.style.getStyle('quests.FTUX'),
            anchor: Point.Center,
            scale: Point.Zero,
        });
        text.addChild(arrow);

        system.animator.addChild(text);
        system.animator.addChild(farmButton);

        // Using this cause RelativePosition Component on text was not being at the correct position in different screen sizes
        const onResize = () => {
            const farmButtonPosition = farmButton.layout.root.container.position.clone();
            const textPositionX = farmButtonPosition.x;
            const textPositionY = farmButtonPosition.y - arrow.container.height - 100;
            text.getComponent(TransformComponent).position = new Point(textPositionX, textPositionY);
        }
        RenderSystem.on(RenderSystemEvent.RESIZE, onResize);
        onResize();

        overlay.getComponent(OverlayComponent).preventInteraction = true;

        yield* ConcatIterators([
            PlayAnimation(new OverlayFadeIn(overlay)),
            PlayAnimation(
                new Scale(text, {
                    startScale: Point.Zero,
                    endScale: Point.One,
                    duration: 250,
                    easing: Easing.Back.Out,
                })
            ),
        ]);

        // Re-enable button to be clickable when task is running
        farmButton.layout.myFarmButton.getComponent(Interactable).toggle();

        // Wait for user interaction
        while (true) {
            yield;
        }
    }
}
